import React from 'react';
import { useLocation } from 'react-router-dom';
import useBusinessTranslation from '../../../hooks/useBusinessTranslation';
import PageHeader from '../../components/misc/PageHeader';
import TransactionsPage from './TransactionsPage';
import BankAccountsPage from './BankAccountsPage';

export default function AdministrationPage(): JSX.Element {
  const { t } = useBusinessTranslation();
  const location = useLocation();
  
  // Set initial tab based on the current path or state
  const getInitialTab = (): 'bankAccounts' | 'transactions' => {
    // Check if state indicates which tab to show
    if (location.state?.activeTab) {
      return location.state.activeTab;
    }
    
    if (location.pathname.includes('/financial/bank-accounts')) {
      return 'bankAccounts';
    }
    if (location.pathname.includes('/financial/transactions')) {
      return 'transactions';
    }
    return 'bankAccounts';
  };
  
  const [activeTab, setActiveTab] = React.useState<'bankAccounts' | 'transactions'>(getInitialTab());

  // Respond to navigation that updates location.state without changing the path
  React.useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  return (
    <>
      <div>
        <PageHeader
          title={t('page.financial.administration.title')}
          subtitle={t('page.financial.administration.subtitle')}
        />

        {/* Tabs */}
        <div className="mb-6 flex gap-4 border-b border-primary-300">
          {(['bankAccounts', 'transactions'] as const).map((tabKey) => (
            <button
              key={tabKey}
              type="button"
              onClick={() => setActiveTab(tabKey)}
              className={`relative px-4 pb-1 pt-2 font-medium transition-all duration-150 ${
                activeTab === tabKey
                  ? 'text-primary-700 -mb-[1px] rounded-t-md border border-primary-300 border-b-secondary-50'
                  : 'text-primary-600 hover:text-primary-800'
              }`}>
              {t(`page.financial.administration.tabs.${tabKey}`)}
            </button>
          ))}
        </div>

        <div className="w-full">
          {activeTab === 'bankAccounts' && <BankAccountsPage hideHeader />}
          {activeTab === 'transactions' && <TransactionsPage hideHeader />}
        </div>
      </div>
    </>
  );
}
